// Find menu item for current booking flow
const findMenuItem = (content_type: string, data:Content) => {
    return data.pages.find(item => item.content_type === content_type);
};

export default findMenuItem
